import { createActions } from 'redux-actions';
import { request } from '../../services';

const {
  surveyFetchRequest,
  surveyFetchSuccess,
  surveyFetchFailure,
} = createActions('SURVEY_FETCH_SUCCESS', 'SURVEY_FETCH_REQUEST', 'SURVEY_FETCH_FAILURE');

export function requestPhaseSurvey(phaseID) {
  return (dispatch) => {
    dispatch(surveyFetchRequest());

    return request(`phases/${phaseID}/survey`)
      .then(({ json }) => dispatch(surveyFetchSuccess(json)))
      .catch(error => dispatch(surveyFetchFailure(error)));
  };
}

const {
  surveyUpdateRequest,
  surveyUpdateSuccess,
  surveyUpdateFailure,
} = createActions('SURVEY_UPDATE_SUCCESS', 'SURVEY_UPDATE_REQUEST', 'SURVEY_UPDATE_FAILURE');

export function updatePhaseSurvey(phaseID, params) {
  return (dispatch) => {
    dispatch(surveyUpdateRequest());

    const questions = params.questions.map(q => ({ id: q.id, answers_attributes: q.answers }));
    const body = { survey: {
      comment: params.comment,
      resolution: params.resolution,
      questions_attributes: questions,
    } };

    return request(`phases/${phaseID}/survey`, { method: 'PATCH', body })
      .then(({ json }) => dispatch(surveyUpdateSuccess(json)))
      .catch(error => dispatch(surveyUpdateFailure(error)));
  };
}

const {
  surveyPoorScoreNotificationRequest,
  surveyPoorScoreNotificationSuccess,
  surveyPoorScoreNotificationFailure,
} = createActions(
  'SURVEY_POOR_SCORE_NOTIFICATION_SUCCESS',
  'SURVEY_POOR_SCORE_NOTIFICATION_REQUEST',
  'SURVEY_POOR_SCORE_NOTIFICATION_FAILURE',
);

export function sendPoorScoreNotification(phaseID, params) {
  return (dispatch) => {
    dispatch(surveyPoorScoreNotificationRequest());
    const body = { email: params };

    return request(`phases/${phaseID}/survey/send_poor_score_notification`, { method: 'POST', body })
      .then(({ json }) => dispatch(surveyPoorScoreNotificationSuccess(json)))
      .catch(error => dispatch(surveyPoorScoreNotificationFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/survey.js